<template>
  <div class="my-5">
    <h2 class="subtitle has-text-centered">Customize</h2>
    <div class="tabs is-centered">
      <ul>
        <li v-bind:class="{ 'is-active': activeTab == 0 }">
          <a @click.prevent="activeTab = 0">1. Voting</a>
        </li>
        <li v-bind:class="{ 'is-active': activeTab == 1 }">
          <a @click.prevent="activeTab = 1">2. Extended Feedback Page</a>
        </li>
        <li
          v-bind:class="{ 'is-active': activeTab == 2 }"
          @click.prevent="activeTab = 2"
        >
          <a>3. Thank You Page</a>
        </li>
        <li v-bind:class="{ 'is-active': activeTab == 3 }">
          <a @click.prevent="activeTab = 3">Advanced</a>
        </li>
      </ul>
    </div>
    <div>
      <div v-if="activeTab == 0">
        <div class="columns is-variable is-8 is-multiline">
          <div class="column">
            <p class="mb-4">
              The voting section is the part you copy and paste into your email.
            </p>
            <div class="field">
              <label class="label" for="thumbsHeadline"
                >Introduction Headline</label
              >
              <div class="control">
                <input
                  v-model="feedbackForm.thumbsHeadline"
                  id="thumbsHeadline"
                  name="thumbsHeadline"
                  type="text"
                  class="input"
                  required
                />
              </div>
            </div>
            <div class="field">
              <label class="label" for="thumbsParagraph"
                >Introduction Text</label
              >
              <div class="control">
                <input
                  v-model="feedbackForm.thumbsParagraph"
                  id="thumbsParagraph"
                  name="thumbsParagraph"
                  type="text"
                  class="input"
                  required
                />
              </div>
            </div>
            <div class="field">
              <label v-if="isNewsletter" class="label" for="thumbsup">Text for Thumbs Up</label>
              <label v-else class="label" for="thumbsup">Text for Voting Option 1</label>
              <div class="control">
                <input
                  v-model="feedbackForm.thumbsup"
                  id="thumbsup"
                  name="thumbsup"
                  type="text"
                  class="input"
                  required
                />
                
              </div>
              <p class="help">
                First word is used as the label in the Admin UI
              </p>
            </div>

            <div class="field">
              <label v-if="isNewsletter" class="label" for="thumbsok">Text for Thumbs Ok</label>
              <label v-else class="label" for="thumbsok">Text for Voting Option 2</label>
              <div class="control">
                <input
                  v-model="feedbackForm.thumbsok"
                  id="thumbsok"
                  name="thumbsok"
                  type="text"
                  class="input"
                  required
                />
              </div>
              <p class="help">
                First word is used as the label in the Admin UI
              </p>
            </div>

            <div class="field">
              <label v-if="isNewsletter" class="label" for="thumbsdown">Text for Thumbs Down</label>
              <label v-else class="label" for="thumbsdown">Text for Voting Option 3</label>
              <div class="control">
                <input
                  v-model="feedbackForm.thumbsdown"
                  id="thumbsdown"
                  name="thumbsdown"
                  type="text"
                  class="input"
                  required
                />
              </div>
              <p class="help">
                First word is used as the label in the Admin UI
              </p>
            </div>
            <div v-if="!isNewsletter" class="field">
              <label class="label" for="thumbsoption4"
                >Text for Voting Option 4
                <span
                  v-if="!account.has_pro_features"
                  class="tag is-success"
                  >PRO</span
                >
                <router-link
                  v-if="!account.has_pro_features"
                  :to="{ name: 'Upgrade' }"
                  class="tag is-info"
                  >Unlock Now</router-link
                >
              </label>
              <div class="control">
                <input
                  v-model="feedbackForm.thumbsoption4"
                  id="thumbsoption4"
                  name="thumbsoption4"
                  type="text"
                  placeholder="A forth voting option"
                  class="input"
                  :disabled="!account.has_pro_features"
                />
              </div>
              <p class="help">
                First word is used as the label in the Admin UI
              </p>
            </div>
            <div  v-if="!isNewsletter" class="field">
              <label class="label" for="thumbsoption5"
                >Text for Voting Option 5
                <span
                  v-if="!account.has_pro_features"
                  class="tag is-success"
                  >PRO</span
                >
                <router-link
                  v-if="!account.has_pro_features"
                  :to="{ name: 'Upgrade' }"
                  class="tag is-info"
                  >Unlock Now</router-link
                >
              </label>
              <div class="control">
                <input
                  v-model="feedbackForm.thumbsoption5"
                  id="thumbsoption5"
                  name="thumbsoption5"
                  type="text"
                  placeholder="A fifth voting option"
                  class="input"
                  :disabled="!account.has_pro_features"
                />
              </div>
              <p class="help">
                First word is used as the label in the Admin UI
              </p>
            </div>
          </div>
          <div class="column">
            <h2 class="subtitle">Previews</h2>

            <h3>Theme Bullets</h3>
            <div id="formWidget" class="content is-medium box is-shadowless">
              <p>
                <strong>{{ feedbackForm.thumbsHeadline }}</strong>
              </p>

              <p>{{ feedbackForm.thumbsParagraph }}</p>

              <ul>
                <li>
                  <a>{{ feedbackForm.thumbsup }}</a>
                </li>
                <li v-if="isNewsletter || feedbackForm.thumbsok">
                  <a>{{ feedbackForm.thumbsok }}</a>
                </li>
                <li v-if="isNewsletter ||  feedbackForm.thumbsdown">
                  <a>{{ feedbackForm.thumbsdown }}</a>
                </li>
                <li v-if="!isNewsletter && feedbackForm.thumbsoption4">
                  <a>{{ feedbackForm.thumbsoption4 }}</a>
                </li>
                <li v-if="!isNewsletter && feedbackForm.thumbsoption5">
                  <a>{{ feedbackForm.thumbsoption5 }}</a>
                </li>
              </ul>
            </div>

            <h3>Theme Inline</h3>
            <div id="formWidgetAlt" class="content is-medium box is-shadowless">
                <p>
                  <strong>{{ feedbackForm.thumbsHeadline }}</strong>
                </p>

                <p>{{ feedbackForm.thumbsParagraph }}</p>


                  <p>
                    <a
                      :href="'https://feedletter.co/feedback/give/1/'"
                      target="_blank"
                      >{{ feedbackForm.thumbsup }}</a
                    >
                    <template  v-if="isNewsletter ||  feedbackForm.thumbsok">
 - 
                    <a
                      :href="'https://feedletter.co/feedback/give/2/'"
                      target="_blank"
                      >{{ feedbackForm.thumbsok }}</a
                    >
                    </template>
                    <template  v-if="isNewsletter ||  feedbackForm.thumbsdown">
 - 
                    <a
                      :href="'https://feedletter.co/feedback/give/3/'"
                      target="_blank"
                      >{{ feedbackForm.thumbsdown }}</a
                    >
                    </template>
                    <template v-if="!isNewsletter && feedbackForm.thumbsoption4">
 - 
                    <a
                      :href="'https://feedletter.co/feedback/give/4/'"
                      target="_blank"
                      >{{ feedbackForm.thumbsoption4 }}</a
                    >
                    </template>
                    <template v-if="!isNewsletter && feedbackForm.thumbsoption5">
 - 
                    <a
                      :href="'https://feedletter.co/feedback/give/5/' + formId"
                      target="_blank"
                      >{{ feedbackForm.thumbsoption5 }}</a
                    >
                    </template>
                  </p>
              </div>
          </div>
        </div>
      </div>

      <div v-if="activeTab == 1">
        <div class="columns is-variable is-8 is-multiline">
          <div class="column">
            <p class="mb-4">
              The Extended Feedback Page is shown when the reader clicks on a
              link in the voting section. The vote is already registered, and
              you can collect additional input from the user.
            </p>
            <p v-if="isNewsletter" class="mb-3">
              NAME is placeholder and replaced with your name plus appending
              <em>'s</em>.
            </p>
            <p v-if="feedbackForm.efpEnabled == '0'" class="mt-5 notification is-warning">
              You disabled the Extended Feedback Page. You will miss out on the more essential benefit of reader's comments!

              <br />
              Enable it under the Advanced tab.
            </p>
            <div class="field">
              <label class="label" for="thankYouLine"
                >Thank You Text
                <span
                  v-if="!account.has_pro_features"
                  class="tag is-success"
                  >PRO</span
                >
                <router-link
                  v-if="!account.has_pro_features"
                  :to="{ name: 'Upgrade' }"
                  class="tag is-info"
                  >Unlock Now</router-link
                >
              </label>
              <div class="control">
                <input
                  v-model="feedbackForm.efpThankYouText"
                  id="thankYouLine"
                  name="thankYouLine"
                  type="text"
                  class="input"
                  :disabled="!account.has_pro_features"
                />
              </div>
            </div>
            <div class="field">
              <label v-if="isNewsletter" class="label" for="thumbsupReasonHeader">Headline For Thumbs Up</label>
              <label v-else class="label" for="thumbsupReasonHeader"
                >Headline When Voted "{{feedbackForm.thumbsup}}"</label
              >
              <div class="control">
                <input
                  v-model="feedbackForm.efpThumbsupReasonHeader"
                  id="thumbsupReasonHeader"
                  name="thumbsupReasonHeader"
                  type="text"
                  class="input"
                  v-on:focus="setEfpPreview(feedbackForm)"
                />
              </div>
            </div>

            <div v-if="!isNewsletter || feedbackForm.thumbsok" class="field">
              <label v-if="isNewsletter" class="label" for="thumbsokReasonHeader">Headline For Thumbs Ok</label>
              <label v-else class="label" for="thumbsokReasonHeader"
                >Headline When Voted "{{feedbackForm.thumbsok}}"</label
              >
              <div class="control">
                <input
                  v-model="feedbackForm.efpThumbsokReasonHeader"
                  id="thumbsokReasonHeader"
                  name="thumbsokReasonHeader"
                  type="text"
                  class="input"
                  v-on:focus="setEfpPreview(feedbackForm)"
                />
              </div>
            </div>

            <div v-if="!isNewsletter || feedbackForm.thumbsdown" class="field">
              <label v-if="isNewsletter" class="label" for="thumbsdownReasonHeader">Headline For Thumbs Down</label>
              <label v-else class="label" for="thumbsdownReasonHeader"
                >Headline When Voted "{{feedbackForm.thumbsdown}}"</label
              >
              <div class="control">
                <input
                  v-model="feedbackForm.efpThumbsdownReasonHeader"
                  id="thumbsdownReasonHeader"
                  name="thumbsdownReasonHeader"
                  type="text"
                  class="input"
                  v-on:focus="setEfpPreview(feedbackForm)"
                />
              </div>
            </div>
            <div v-if="!isNewsletter && feedbackForm.thumbsoption4" class="field">
              <label class="label" for="efpThumbsoption4ReasonHeader"
                >Headline When Voted "{{feedbackForm.thumbsoption4}}"
                <span
                  v-if="!account.has_pro_features"
                  class="tag is-success"
                  >PRO</span
                >
                <router-link
                  v-if="!account.has_pro_features"
                  :to="{ name: 'Upgrade' }"
                  class="tag is-info"
                  >Unlock Now</router-link
                >
              </label>
              <div class="control">
                <input
                  v-model="feedbackForm.efpThumbsoption4ReasonHeader"
                  id="efpThumbsoption4ReasonHeader"
                  name="efpThumbsoption4ReasonHeader"
                  type="text"
                  class="input"
                  :disabled="!account.has_pro_features"
                  v-on:focus="setEfpPreview(feedbackForm)"
                />
              </div>
            </div>
            <div v-if="!isNewsletter && feedbackForm.thumbsoption5" class="field">
              <label class="label" for="efpThumbsoption5ReasonHeader"
                >Headline When Voted "{{feedbackForm.thumbsoption5}}"
                <span
                  v-if="!account.has_pro_features"
                  class="tag is-success"
                  >PRO</span
                >
                <router-link
                  v-if="!account.has_pro_features"
                  :to="{ name: 'Upgrade' }"
                  class="tag is-info"
                  >Unlock Now</router-link
                >
              </label>
              <div class="control">
                <input
                  v-model="feedbackForm.efpThumbsoption5ReasonHeader"
                  id="efpThumbsoption5ReasonHeader"
                  name="efpThumbsoption5ReasonHeader"
                  type="text"
                  class="input"
                  :disabled="!account.has_pro_features"
                  v-on:focus="setEfpPreview(feedbackForm)"
                />
              </div>
            </div>
            <div class="field">
              <label class="label" for="efpWhyBoxText"
                >Reason Box Label
                <span
                  v-if="!account.has_pro_features"
                  class="tag is-success"
                  >PRO</span
                >
                <router-link
                  v-if="!account.has_pro_features"
                  :to="{ name: 'Upgrade' }"
                  class="tag is-info"
                  >Unlock Now</router-link
                >
              </label>
              <div class="control">
                <input
                  v-model="feedbackForm.efpWhyBoxText"
                  id="efpWhyBoxText"
                  name="efpWhyBoxText"
                  type="text"
                  class="input"
                  :disabled="!account.has_pro_features"
                />
              </div>
            </div>
            <div class="field">
              <label class="label" for="efpWhyBoxPlaceholder"
                >Reason Box Placeholder
                <span
                  v-if="!account.has_pro_features"
                  class="tag is-success"
                  >PRO</span
                >
                <router-link
                  v-if="!account.has_pro_features"
                  :to="{ name: 'Upgrade' }"
                  class="tag is-info"
                  >Unlock Now</router-link
                >
              </label>
              <div class="control">
                <input
                  v-model="feedbackForm.efpWhyBoxPlaceholder"
                  id="efpWhyBoxPlaceholder"
                  name="efpWhyBoxPlaceholder"
                  type="text"
                  class="input"
                  :disabled="!account.has_pro_features"
                />
              </div>
            </div>
            <div class="field">
              <label class="label" for="efpAllowAudioFeedback"
                >Allow Audio Feedback
                <span
                  v-if="!account.has_pro_features"
                  class="tag is-success"
                  >PRO</span
                >
                <router-link
                  v-if="!account.has_pro_features"
                  :to="{ name: 'Upgrade' }"
                  class="tag is-info"
                  >Unlock Now</router-link
                >
              </label>
              <div class="control">
                <label class="radio">
                  <input type="radio" name="efpAllowAudioFeedback" v-model="feedbackForm.efpAllowAudioFeedback" value="1" :disabled="!account.has_pro_features">
                  yes
                </label>
                <label class="radio">
                  <input type="radio" name="efpAllowAudioFeedback" v-model="feedbackForm.efpAllowAudioFeedback" value="0" :disabled="!account.has_pro_features">
                  no
                </label>
              </div>
              <p class="help">
                You can disable audio feedback.
              </p>
            </div>
            
            <div v-if="feedbackForm.efpAllowAudioFeedback ==='1'" class="field">
              <label class="label" for="efpVoiceText"
                >Label to switch to the audio feedback panel
                <span
                  v-if="!account.has_pro_features"
                  class="tag is-success"
                  >PRO</span
                >
                <router-link
                  v-if="!account.has_pro_features"
                  :to="{ name: 'Upgrade' }"
                  class="tag is-info"
                  >Unlock Now</router-link
                >
              </label>
              <div class="control">
                <input
                  v-model="feedbackForm.efpVoiceText"
                  id="efpVoiceText"
                  name="efpVoiceText"
                  type="text"
                  class="input"
                  :disabled="!account.has_pro_features"
                />
              </div>
            </div>
            <div v-if="feedbackForm.efpAllowAudioFeedback ==='1'" class="field">
              <label class="label" for="efpVoiceRemainingText"
                >Label remaining time on the audio feedback panel
                <span
                  v-if="!account.has_pro_features"
                  class="tag is-success"
                  >PRO</span
                >
                <router-link
                  v-if="!account.has_pro_features"
                  :to="{ name: 'Upgrade' }"
                  class="tag is-info"
                  >Unlock Now</router-link
                >
              </label>
              <div class="control">
                <input
                  v-model="feedbackForm.efpVoiceRemainingText"
                  id="efpVoiceRemainingText"
                  name="efpVoiceRemainingText"
                  type="text"
                  class="input"
                  :disabled="!account.has_pro_features"
                />
              </div>
            </div>
            <div v-if="feedbackForm.efpAllowAudioFeedback ==='1'" class="field">
              <label class="label" for="efpTextMsgText"
                >Label to switch back to the text feedback panel
                <span
                  v-if="!account.has_pro_features"
                  class="tag is-success"
                  >PRO</span
                >
                <router-link
                  v-if="!account.has_pro_features"
                  :to="{ name: 'Upgrade' }"
                  class="tag is-info"
                  >Unlock Now</router-link
                >
              </label>
              <div class="control">
                <input
                  v-model="feedbackForm.efpTextMsgText"
                  id="efpTextMsgText"
                  name="efpTextMsgText"
                  type="text"
                  class="input"
                  :disabled="!account.has_pro_features"
                />
              </div>
            </div>
            <div class="field">
              <label class="label" for="efpReaderNamePlaceholder"
                >Gather Reader's Name Placeholder
                <span
                  v-if="!account.has_pro_features"
                  class="tag is-success"
                  >PRO</span
                >
                <router-link
                  v-if="!account.has_pro_features"
                  :to="{ name: 'Upgrade' }"
                  class="tag is-info"
                  >Unlock Now</router-link
                >
              </label>
              <div class="control">
                <input
                  v-model="feedbackForm.efpReaderNamePlaceholder"
                  id="efpReaderNamePlaceholder"
                  name="efpReaderNamePlaceholder"
                  type="text"
                  class="input"
                  :disabled="!account.has_pro_features"
                />
              </div>
            </div>
            <div class="field">
              <label class="label" for="efpReaderEmailPlaceholder"
                >Gather Reader's Email Address Placeholder
                <span
                  v-if="!account.has_pro_features"
                  class="tag is-success"
                  >PRO</span
                >
                <router-link
                  v-if="!account.has_pro_features"
                  :to="{ name: 'Upgrade' }"
                  class="tag is-info"
                  >Unlock Now</router-link
                >
              </label>
              <div class="control">
                <input
                  v-model="feedbackForm.efpReaderEmailPlaceholder"
                  id="efpReaderEmailPlaceholder"
                  name="efpReaderEmailPlaceholder"
                  type="text"
                  class="input"
                  :disabled="!account.has_pro_features"
                />
              </div>
              <p class="help">
                Leave the field empty to hide the input box on the extended feedback page.
              </p>
            </div>
            
            <div class="field">
              <label class="label" for="efpButtonText"
                >Button Text
                <span
                  v-if="!account.has_pro_features"
                  class="tag is-success"
                  >PRO</span
                >
                <router-link
                  v-if="!account.has_pro_features"
                  :to="{ name: 'Upgrade' }"
                  class="tag is-info"
                  >Unlock Now</router-link
                >
              </label>
              <div class="control">
                <input
                  v-model="feedbackForm.efpButtonText"
                  id="efpButtonText"
                  name="efpButtonText"
                  type="text"
                  class="input"
                  :disabled="!account.has_pro_features"
                />
              </div>
            </div>
          </div>
          <div class="column">
            <h2 class="subtitle">Preview</h2>
            <iframe
              id="efpPreview"
              @load="setEfpPreview(feedbackForm)"
              class="previewFrame"
              src="/previews/feedback.html"
            >
            </iframe>
          </div>
        </div>
      </div>
      <div v-if="activeTab == 2">
        <div class="columns is-variable is-8 is-multiline">
          <div class="column">
            <p class="mb-4">
              The Thank You Page is shown to the reader after they gave feedback
              on the Extended Feedback Page.
            </p>
            <div class="field">
              <label class="label" for="typHeadline"
                >Headline
                <span
                  v-if="!account.has_pro_features"
                  class="tag is-success"
                  >PRO</span
                >
                <router-link
                  v-if="!account.has_pro_features"
                  :to="{ name: 'Upgrade' }"
                  class="tag is-info"
                  >Unlock Now</router-link
                >
              </label>
              <div class="control">
                <input
                  v-model="feedbackForm.typHeadline"
                  id="typHeadline"
                  name="typHeadline"
                  type="text"
                  class="input"
                  :disabled="!account.has_pro_features"
                />
              </div>
            </div>
            <div class="field">
              <label class="label" for="typSubHeadline"
                >Subheadline
                <span
                  v-if="!account.has_pro_features"
                  class="tag is-success"
                  >PRO</span
                >
                <router-link
                  v-if="!account.has_pro_features"
                  :to="{ name: 'Upgrade' }"
                  class="tag is-info"
                  >Unlock Now</router-link
                >
              </label>
              <div class="control">
                <input
                  v-model="feedbackForm.typSubHeadline"
                  id="typSubHeadline"
                  name="typSubHeadline"
                  type="text"
                  class="input"
                  :disabled="!account.has_pro_features"
                />
              </div>
            </div>
            <div class="field">
              <label class="label" for="typShareTwitterHandle"
                >Your Twitter Username Without @
              </label>
              <div class="control">
                <input
                  v-model="feedbackForm.typShareTwitterHandle"
                  id="typShareTwitterHandle"
                  name="typShareTwitterHandle"
                  type="text"
                  class="input"
                />
              </div>
              <p class="help">
                Enter your twitter handle to activate the share button.
              </p>
            </div>
            <div class="field">
              <label class="label" for="typShareButtonTwitter"
                >Text of the Twitter Share Button
              </label>
              <div class="control">
                <input
                  v-model="feedbackForm.typShareButtonTwitter"
                  id="typShareButtonTwitter"
                  name="typShareButtonTwitter"
                  type="text"
                  class="input"
                />
              </div>
            </div>
            <div class="field">
              <label class="label" for="typRedirect"
                >Redirect
                <span
                  v-if="!account.has_pro_features"
                  class="tag is-success"
                  >PRO</span
                >
                <router-link
                  v-if="!account.has_pro_features"
                  :to="{ name: 'Upgrade' }"
                  class="tag is-info"
                  >Unlock Now</router-link
                >
              </label>
              <div class="control">
                <input
                  v-model="feedbackForm.typRedirect"
                  id="typRedirect"
                  name="typRedirect"
                  type="url"
                  class="input"
                  placeholder="https://mydomain.com/myredirect"
                  :disabled="!account.has_pro_features"
                />
              </div>
              <p class="help" >
                Use <i>{email}</i> as a placeholder in a parameter to receive the reader's email address. When it was prefilled via MergeTags or when the reader entered one,
              </p>
            </div>
          </div>
          <div class="column">
            <h2 class="subtitle">Preview</h2>

            <iframe
              id="typPreview"
              @load="setTypPreview(feedbackForm)"
              class="previewFrame"
              src="/previews/thankyou.html"
            >
            </iframe>
          </div>
        </div>
      </div>
      <div v-if="activeTab == 3">
        <div class="columns is-variable is-8 is-multiline">
          <div class="column is-half">
            <div class="field is-relative" id="efpNotificationEmailBlock">
              <label class="label" for="efpNotificationEmail"
                >Receive An Email On New Feedback
                <span
                  v-if="!account.has_pro_features"
                  class="tag is-success"
                  >PRO</span
                >
                <router-link
                  v-if="!account.has_pro_features"
                  :to="{ name: 'Upgrade' }"
                  class="tag is-info"
                  >Unlock Now</router-link
                >
              </label>
              <div class="control">
                <input
                  v-model="feedbackForm.efpNotificationEmail"
                  id="efpNotificationEmail"
                  name="efpNotificationEmail"
                  type="email"
                  class="input"
                  placeholder="Enter an email address to be notified when a new extendend feedback is posted"
                  :disabled="!account.has_pro_features"
                />
                
              </div>
              <p class="help" >
                <a @click.prevent="sendTestNotificationEmail" >Send Test Email</a>
              </p>
            </div>
            <div class="field is-relative" id="efpNotificationWebhookBlock">
              <label class="label" for="efpNotificationWebhookURL"
                >Webhook On New Feedback
                <span
                  v-if="!account.has_biz_features"
                  class="tag is-warning"
                  >BIZ</span
                >
                <router-link
                  v-if="!account.has_biz_features"
                  :to="{ name: 'Upgrade' }"
                  class="tag is-info"
                  >Unlock Now</router-link
                >
              </label>
              <div class="control">
                <input
                  v-model="feedbackForm.efpNotificationWebhookURL"
                  id="efpNotificationWebhookURL"
                  name="efpNotificationWebhookURL"
                  type="url"
                  class="input"
                  placeholder="Enter a URL that accept the feedback webhook"
                  :disabled="!account.has_biz_features"
                />
              </div>
              <p class="help" >
                <a @click.prevent="sendTestNotificationWebhook" >Send Test Webhook</a>
              </p>
              <p class="help">More detials in the <a href="/integrations/">help section for Integrations</a>
              </p>
            </div>
            <div class="field">
              <label class="label" for="showBranding"
                >Show FeedLetter Branding
                <span
                  v-if="!account.has_pro_features"
                  class="tag is-success"
                  >PRO</span
                >
                <router-link
                  v-if="!account.has_pro_features"
                  :to="{ name: 'Upgrade' }"
                  class="tag is-info"
                  >Unlock Now</router-link
                >
              </label>
              <div class="control">
                <label class="radio">
                  <input type="radio" name="showBranding" v-model="feedbackForm.showBranding" value="1" :disabled="!account.has_pro_features">
                  yes
                </label>
                <label class="radio">
                  <input type="radio" name="showBranding" v-model="feedbackForm.showBranding" value="0" :disabled="!account.has_pro_features">
                  no
                </label>
              </div>
              <p class="help">
                You can remove the FeedLetter branding on the widget and feedback page.
              </p>
            </div>
            <div class="field">
              <label class="label" for="efpEnabled"
                >Enable Extended Feedback Page
                <span
                  v-if="!account.has_pro_features"
                  class="tag is-success"
                  >PRO</span
                >
                <router-link
                  v-if="!account.has_pro_features"
                  :to="{ name: 'Upgrade' }"
                  class="tag is-info"
                  >Unlock Now</router-link
                >
              </label>
              <div class="control">
                <label class="radio">
                  <input type="radio" name="efpEnabled" v-model="feedbackForm.efpEnabled" value="1" :disabled="!account.has_pro_features">
                  yes
                </label>
                <label class="radio">
                  <input type="radio" name="efpEnabled" v-model="feedbackForm.efpEnabled" value="0" :disabled="!account.has_pro_features">
                  no
                </label>
              </div>
              <p class="help is-danger">
                If you disable the Extended Feedback Page, you will miss out on the more essential benefit of reader's comments!
              </p>
            </div>
            <div class="field">
              <label class="label" for="efpPrefillEmail"
                >Prefill Email Address If in Request
                <span
                  v-if="!account.has_pro_features"
                  class="tag is-success"
                  >PRO</span
                >
                <router-link
                  v-if="!account.has_pro_features"
                  :to="{ name: 'Upgrade' }"
                  class="tag is-info"
                  >Unlock Now</router-link
                >
              </label>
              <div class="control">
                <label class="radio">
                  <input type="radio" name="efpPrefillEmail" v-model="feedbackForm.efpPrefillEmail" value="1" :disabled="!account.has_pro_features">
                  yes
                </label>
                <label class="radio">
                  <input type="radio" name="efpPrefillEmail" v-model="feedbackForm.efpPrefillEmail" value="0" :disabled="!account.has_pro_features">
                  no
                </label>
              </div>
              <p class="help">
                When enabled and an email address is given via the "e" request parameter, it will prefill the email field on the Extended Feedback Page.
              </p>
            </div>
            <div class="field">
              <label class="label" for="efpAllowBlankFeedback"
                >Allow Empty Feedback on Submit
                <span
                  v-if="!account.has_pro_features"
                  class="tag is-success"
                  >PRO</span
                >
                <router-link
                  v-if="!account.has_pro_features"
                  :to="{ name: 'Upgrade' }"
                  class="tag is-info"
                  >Unlock Now</router-link
                >
              </label>
              <div class="control">
                <label class="radio">
                  <input type="radio" name="efpAllowBlankFeedback" v-model="feedbackForm.efpAllowBlankFeedback" value="1" :disabled="!account.has_pro_features">
                  yes
                </label>
                <label class="radio">
                  <input type="radio" name="efpAllowBlankFeedback" v-model="feedbackForm.efpAllowBlankFeedback" value="0" :disabled="!account.has_pro_features">
                  no
                </label>
              </div>
              <p class="help">
                Sometimes, readers don't understand that their vote was already successful or simply want to submit the empty form. If enabled, those comments pass through but are not saved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import atomic from "atomicjs"
import { mapState } from 'vuex'
import { trackEvent } from '../lib/flevents';

export default {
  props: ["feedbackForm",],
  components: {},
  data: function () {
    return {
      activeTab: 0
    };
  },
  methods: {
    setEfpPreview: function (newFeedbackForm) {
      let iframe = document.getElementById("efpPreview");
      if (iframe != null) {

        let tmpName = newFeedbackForm.name
        if(tmpName == null || tmpName === "") {
          tmpName = "this"
        } else {
          tmpName = tmpName + "'s"
        }

        let efpPreviewFrame =
          iframe.contentDocument || iframe.contentWindow.document;

        if (newFeedbackForm.efpThankYouText === undefined || newFeedbackForm.efpThankYouText === null
        || newFeedbackForm.efpThankYouText === "") {
          efpPreviewFrame.getElementById("efpThankYouTextBox").style.display = "none"
        } else {
          efpPreviewFrame.getElementById("efpThankYouTextBox").style.display = "block"
          efpPreviewFrame.getElementById("efpThankYouText").innerText =
          newFeedbackForm.efpThankYouText;
        }


        let tmpHeader = newFeedbackForm.efpThumbsupReasonHeader
        if (document.getElementById("thumbsokReasonHeader") === document.activeElement) {
          tmpHeader = newFeedbackForm.efpThumbsokReasonHeader
        } else if (document.getElementById("thumbsdownReasonHeader") === document.activeElement) {
          tmpHeader = newFeedbackForm.efpThumbsdownReasonHeader
        } else if (document.getElementById("efpThumbsoption4ReasonHeader") === document.activeElement) {
          tmpHeader = newFeedbackForm.efpThumbsoption4ReasonHeader || ""
        } else if (document.getElementById("efpThumbsoption5ReasonHeader") === document.activeElement) {
          tmpHeader = newFeedbackForm.efpThumbsoption5ReasonHeader || ""
        }
        efpPreviewFrame.getElementById("efpHeader").innerText =
          tmpHeader.replace(
            "NAME",
            tmpName
          ),
        efpPreviewFrame.getElementById("efpWhyBoxText").innerText =
          newFeedbackForm.efpWhyBoxText;
        efpPreviewFrame.getElementById("efpWhyBoxPlaceholder").placeholder =
          newFeedbackForm.efpWhyBoxPlaceholder;
        efpPreviewFrame.getElementById("efpReaderNamePlaceholder").placeholder =
          newFeedbackForm.efpReaderNamePlaceholder;
        efpPreviewFrame.getElementById("efpReaderEmailPlaceholder").placeholder =
          newFeedbackForm.efpReaderEmailPlaceholder || ""
        if (newFeedbackForm.efpReaderEmailPlaceholder === undefined || newFeedbackForm.efpReaderEmailPlaceholder === null
        || newFeedbackForm.efpReaderEmailPlaceholder === "") {
          efpPreviewFrame.getElementById("efpReaderEmailPlaceholder").style.display = "none"
        } else {
          efpPreviewFrame.getElementById("efpReaderEmailPlaceholder").style.display = "block"
        }
          
        efpPreviewFrame.getElementById("efpButtonText").innerText =
          newFeedbackForm.efpButtonText;
        
        let voiceT = newFeedbackForm.efpVoiceText
        if (newFeedbackForm.efpAllowAudioFeedback === '0' ) {
          voiceT = ""
        }
        efpPreviewFrame.getElementById("efpVoiceText").innerText = voiceT
          
      }
    },
    setTypPreview: function (newFeedbackForm) {
      let iframe = document.getElementById("typPreview");
      if (iframe != null) {
        let typPreviewFrame =
          iframe.contentDocument || iframe.contentWindow.document;
        typPreviewFrame.getElementById("typHeadline").innerText =
          newFeedbackForm.typHeadline;
        typPreviewFrame.getElementById("typSubHeadline").innerText =
          newFeedbackForm.typSubHeadline;
        typPreviewFrame.getElementById("typShareButtonTwitter").innerText =
          newFeedbackForm.typShareButtonTwitter
        if (newFeedbackForm.typShareTwitterHandle === undefined || newFeedbackForm.typShareTwitterHandle === null
        || newFeedbackForm.typShareTwitterHandle === "") {
          typPreviewFrame.getElementById("typShareTwitterHandle").style.display = "none"
        } else {
          typPreviewFrame.getElementById("typShareTwitterHandle").style.display = "block"
        }
      }
    },

    sendTestNotificationEmail: async function() {

      if(this.isEmptyOrSpaces(this.feedbackForm.efpNotificationEmail)) {
        return
      }
      var self = this;

      let loadingComponent = this.$buefy.loading.open({
        container: document.getElementById("efpNotificationEmailBlock")
      })
      this.$store.dispatch('getAPIToken')
        .then((response) => {
          atomic(self.apiHost + "test/email?e=" + self.feedbackForm.efpNotificationEmail, {
            method: "GET",
            headers: {
              Authorization: "Bearer " + response
            },
          })
            .then(function (response) {
              loadingComponent.close()
              self.$buefy.toast.open({
                duration: 3000,
                message: `Test eMail notification was sent.`,
                type: 'is-success'
              })
              //console.log(response.data); // xhr.responseText
              //console.log(response.xhr); // full response
            })
            .catch(function (error) {
              loadingComponent.close()
              console.log(error.status); // xhr.status
              console.log(error.statusText); // xhr.statusText
            });
        })
        .catch((error) => {
          this.$parent.$emit("unauthed")
        });
    },
    sendTestNotificationWebhook: async function() {
      if(this.isEmptyOrSpaces(this.feedbackForm.efpNotificationWebhookURL)) {
        return
      }
      var self = this;
      let loadingComponent = this.$buefy.loading.open({
        container: document.getElementById("efpNotificationWebhookBlock")
      })
      this.$store.dispatch('getAPIToken')
        .then((response) => {
          atomic(self.apiHost + "test/webhook?h=" + self.feedbackForm.efpNotificationWebhookURL, {
            method: "GET",
            headers: {
              Authorization: "Bearer " + response
            },
          })
            .then(function (response) {
              loadingComponent.close()
              self.$buefy.toast.open({
                duration: 3000,
                message: `Test Webhook notification was sent.`,
                type: 'is-success'
              })
              //console.log(response.data); // xhr.responseText
              //console.log(response.xhr); // full response
            })
            .catch(function (error) {
              loadingComponent.close()
              console.log(error.status); // xhr.status
              console.log(error.statusText); // xhr.statusText
            });
        })
        .catch((error) => {
          this.$parent.$emit("unauthed")
        });
    }
  },
  computed: {
    ...mapState([
      "user",
      "account",
    ]),
    isNewsletter() {
      return this.feedbackForm.formType === "newsletter"
    },

  },
  watch: {
    feedbackForm: {
      handler(newFeedbackForm, oldVal) {
        this.setEfpPreview(newFeedbackForm)
        this.setTypPreview(newFeedbackForm)
      },
      deep: true,
      immediate: true,
    },
    activeTab: function (val) {
      trackEvent(this.$store.state.user.id, "survey-edit-tab-view-" + this.activeTab)
    }
  },
};
</script>
<style scoped>
</style>
